import AmpersandCollection from 'ampersand-collection';
import ModuleModel from './module';

const Modules = AmpersandCollection.extend({
    model: ModuleModel

});

module.exports = Modules;